import { Observable } from 'rxjs';
import { ApiService } from '../api.service';
import { Item } from '../../data/data.generated';
import { TableResult, TableView } from './table';

export class Projects {
  constructor(private _api: ApiService) {}

  public GetItems(listOptions: TableView): Observable<TableResult<Item>> {
    return this._api.Get<TableResult<Item>>('GetItems', {
      ...listOptions,
    });
  }

  public GetProjectOrderDetails(projectId: string): Observable<any> {
    return this._api.Get<any>('GetProjectOrderDetails', {
      projectId: projectId,
    });
  }
  
}
